import { render, staticRenderFns } from "./ContenidoJuego.vue?vue&type=template&id=8b3cecda"
import script from "./ContenidoJuego.vue?vue&type=script&lang=js"
export * from "./ContenidoJuego.vue?vue&type=script&lang=js"
import style0 from "./ContenidoJuego.vue?vue&type=style&index=0&id=8b3cecda&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports